// extracted by mini-css-extract-plugin
module.exports = {"Container":"AddMobile_Container__108hm","MobileIcon":"AddMobile_MobileIcon__3-GOg","Header":"AddMobile_Header__3zR0U","Skip":"AddMobile_Skip__3KImk"};